export const routes = [
  {
    path: '/events',
    /* internal name: '/events' */
    /* no component */
    children: [
      {
        path: '',
        name: '/events/',
        component: () => import('/app/src/pages/events/index.vue'),
        /* no children */
      },
      {
        path: ':id',
        /* internal name: '/events/[id]' */
        /* no component */
        children: [
          {
            path: 'attendance',
            name: '/events/[id]/attendance',
            component: () => import('/app/src/pages/events/[id]/attendance.vue'),
            /* no children */
          },
          {
            path: 'detail',
            /* internal name: '/events/[id]/detail' */
            /* no component */
            children: [
              {
                path: '',
                name: '/events/[id]/detail/',
                component: () => import('/app/src/pages/events/[id]/detail/index.vue'),
                /* no children */
              },
              {
                path: ':surveyId',
                /* internal name: '/events/[id]/detail/[surveyId]' */
                /* no component */
                children: [
                  {
                    path: 'survey',
                    name: '/events/[id]/detail/[surveyId]/survey',
                    component: () => import('/app/src/pages/events/[id]/detail/[surveyId]/survey.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'register',
            name: '/events/[id]/register',
            component: () => import('/app/src/pages/events/[id]/register.vue'),
            /* no children */
          }
        ],
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

